var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coin"},_vm._l((_vm.presscoins),function(presscoin,index){return _c('b-container',{key:index,staticClass:"mt-3 mt-md-5"},[_c('b-row',{staticClass:"mb-5 align-items-center"},[_c('b-col',{staticClass:"text-center",attrs:{"sm":"12","md":"7"}},[_c('b-link',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-coin",modifiers:{"modal-coin":true}}],staticClass:"pc-coin pc-coin--large"},[_c('b-img',{attrs:{"src":'https://res.cloudinary.com/presscoins/image/upload/h_350,w_350,c_limit,q_auto/d_contentNodes:presscoins-empty-coin-1.png/c_scale,g_south_west,l_contentNodes:presscoins-classic-logo-dark,w_150,x_10,y_25/v1535414476/pressed-coins/' + presscoin.catalog + '.jpg',"alt":presscoin.catalog,"fluid":""}}),_c('AddCoinFavBtn',{attrs:{"catalog":presscoin.catalog,"size":"large"}})],1),_c('b-modal',{attrs:{"id":"modal-coin","centered":"","lazy":"","hide-footer":"","hide-header":""}},[_c('div',{staticClass:"text-center"},[_c('b-img-lazy',{attrs:{"src":'https://res.cloudinary.com/presscoins/image/upload/d_contentNodes:presscoins-empty-coin-1.png/c_scale,g_south_west,l_contentNodes:presscoins-classic-logo-dark,w_150,x_10,y_25/v1535414476/pressed-coins/' + presscoin.catalog + '.jpg',"alt":presscoin.catalog,"fluid":""}})],1)])],1),_c('b-col',{attrs:{"sm":"12","md":"5"}},[(_vm.isRoleOnUser('admin') && presscoin.verified && presscoin.available == 'True')?_c('b-card',{staticClass:"mb-4"},[_c('small',[_vm._v("Last Verified ")]),_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Admin Only")]),_c('p',[_vm._v(_vm._s(_vm._f("moment")(presscoin.verified,"dddd, MMMM Do YYYY"))+" ("+_vm._s(_vm._f("moment")(presscoin.verified,"from", "now", true))+" ago)")]),_c('b-button',{staticClass:"mb-2",attrs:{"variant":"primary","block":""},on:{"click":function($event){return _vm.verifyCoin()}}},[_c('font-awesome-icon',{attrs:{"icon":['far', 'check']}}),_vm._v(" Check-off")],1)],1):_vm._e(),_c('h1',{staticClass:"mb-1"},[_vm._v(_vm._s(presscoin.shortdesc)+" Pressed "),(presscoin.coin == 'Cent')?_c('span',[_vm._v("Penny")]):_vm._e(),(presscoin.coin != 'Cent')?_c('span',[_vm._v(_vm._s(presscoin.coin))]):_vm._e()]),_c('p',[_c('small',[(presscoin.place)?_c('span',[_vm._v(_vm._s(presscoin.place))]):_vm._e(),(presscoin.area)?_c('span',[_vm._v(" | "+_vm._s(presscoin.area)+" ")]):_vm._e(),(presscoin.location)?_c('span',[_vm._v(" | "),_c('b-link',{attrs:{"to":'/machine/' + presscoin.machine}},[_vm._v(_vm._s(presscoin.location))])],1):_vm._e()])]),(presscoin.description)?_c('p',[_vm._v(_vm._s(presscoin.description))]):_vm._e(),_c('b-container',{staticClass:"p-0"},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('small',[_vm._v("Catalog Number "),_c('b-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"to":"/page/disney-pressed-coin-catalog-numbers","title":"Info"}},[_c('font-awesome-icon',{attrs:{"icon":['far', 'info-circle']}})],1)],1),(presscoin.catalog)?_c('p',[_vm._v(_vm._s(presscoin.catalog)+" "),(presscoin.available == 'True')?_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v("Available")]):_vm._e(),(presscoin.available == 'False')?_c('b-badge',{attrs:{"variant":"secondary"}},[_vm._v("Retired")]):_vm._e()],1):_vm._e()]),(presscoin.newcatalog && presscoin.catalog != presscoin.newcatalog)?_c('b-col',{attrs:{"sm":"6"}},[_c('small',[_vm._v("New Catalog Number "),_c('b-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"to":"/page/disney-pressed-coin-catalog-numbers","title":"Info"}},[_c('font-awesome-icon',{attrs:{"icon":['far', 'info-circle']}})],1)],1),_c('p',[_vm._v(_vm._s(presscoin.newcatalog)+" "),(presscoin.available == 'True')?_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v("Available")]):_vm._e(),(presscoin.available == 'False')?_c('b-badge',{attrs:{"variant":"secondary"}},[_vm._v("Retired")]):_vm._e()],1)]):_vm._e(),_c('b-col',{attrs:{"sm":"6"}},[(presscoin.machine_type)?_c('div',[_c('small',[_vm._v("Machine Type ")]),_c('p',[_vm._v(_vm._s(presscoin.machine_type))])]):_vm._e()])],1)],1),_c('div',[_c('add-to-collection-btn',{attrs:{"catalog":presscoin.catalog,"title":presscoin.shortdesc,"coinType":presscoin.coin}})],1),_c('social-sharing',{attrs:{"url":'https://beta.presscoins.com/pressed-coin/' + presscoin.catalog,"title":presscoin.shortdesc,"description":presscoin.description,"media":'https://res.cloudinary.com/presscoins/image/upload/d_contentNodes:presscoins-empty-coin-1.png/c_scale,g_south_west,l_contentNodes:presscoins-classic-logo-dark,w_150,x_10,y_25/v1535414476/pressed-coins/' + presscoin.catalog + '.jpg',"hashtags":"presscoins","twitter-user":"presscoins"},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4 mb-2"},[_c('network',{attrs:{"network":"facebook"}},[_c('b-badge',{staticClass:"px-3 py-2 b-facebook mr-1",attrs:{"pill":"","variant":"primary"}},[_c('font-awesome-icon',{attrs:{"icon":{ prefix: 'fab', iconName: 'facebook-f' }}}),_vm._v(" Facebook")],1)],1),_c('network',{attrs:{"network":"pinterest"}},[_c('b-badge',{staticClass:"px-3 py-2 b-pinterest mr-1",attrs:{"pill":"","variant":"primary"}},[_c('font-awesome-icon',{attrs:{"icon":{ prefix: 'fab', iconName: 'pinterest' }}}),_vm._v(" Pinterest")],1)],1),_c('network',{attrs:{"network":"twitter"}},[_c('b-badge',{staticClass:"px-3 py-2 b-twitter",attrs:{"pill":"","variant":"primary"}},[_c('font-awesome-icon',{attrs:{"icon":{ prefix: 'fab', iconName: 'twitter' }}}),_vm._v(" Twitter")],1)],1)],1)},staticRenderFns:[]}})],1)],1),_c('b-row',{staticClass:"mb-5"},[_c('b-col',[(presscoin.series)?_c('section',{staticClass:"presscoins-series mb-4"},[_c('h4',{staticClass:"mb-0"},[_vm._v("More "+_vm._s(presscoin.series)+" Series Pressed "),(presscoin.coin == 'Cent')?_c('span',[_vm._v("Pennies")]):_vm._e(),(presscoin.coin != 'Cent')?_c('span',[_vm._v(_vm._s(presscoin.coin)+"s")]):_vm._e()]),_c('p',{staticClass:"mb-0"},[_vm._v("Below you can see other coins from the "+_vm._s(presscoin.series)+" series.")]),_c('coins-by-series',{attrs:{"series":presscoin.series}})],1):_vm._e(),(presscoin.variation)?_c('section',{staticClass:"presscoins-variations mb-4"},[_c('h4',{staticClass:"mb-0"},[_vm._v("Other Variations of the "+_vm._s(presscoin.variation)+" Pressed "),(presscoin.coin == 'Cent')?_c('span',[_vm._v("Penny")]):_vm._e(),(presscoin.coin != 'Cent')?_c('span',[_vm._v(_vm._s(presscoin.coin))]):_vm._e()]),_c('p',{staticClass:"mb-0"},[_vm._v("Below you can see other "+_vm._s(presscoin.series)+" variations.")]),_c('coins-by-variation',{attrs:{"variation":presscoin.variation}})],1):_vm._e(),(presscoin.machine)?_c('section',{staticClass:"presscoins-machines mb-4"},[_c('h4',{staticClass:"mb-0"},[_vm._v("More Pressed "),(presscoin.coin == 'Cent')?_c('span',[_vm._v("Pennies")]):_vm._e(),(presscoin.coin != 'Cent')?_c('span',[_vm._v(_vm._s(presscoin.coin)+"s")]):_vm._e(),_vm._v(" from this Machine")]),_c('p',{staticClass:"mb-0"},[_vm._v("These are the pressed "),(presscoin.coin == 'Cent')?_c('span',[_vm._v("pennies")]):_vm._e(),(presscoin.coin != 'Cent')?_c('span',[_vm._v(_vm._s(presscoin.coin)+"s")]):_vm._e(),_vm._v(" that are currently available at "+_vm._s(presscoin.location)+".")]),_c('coins-by-machine',{attrs:{"machine":presscoin.machine}})],1):_vm._e(),(presscoin.latitude)?_c('section',{staticClass:"presscoins-map mb-4"},[_c('h4',{staticClass:"mb-0"},[_vm._v("Find this Pressed "),(presscoin.coin == 'Cent')?_c('span',[_vm._v("Penny")]):_vm._e(),(presscoin.coin != 'Cent')?_c('span',[_vm._v(_vm._s(presscoin.coin)+"s")]):_vm._e()]),_c('p',[_vm._v("You can find these coin at "+_vm._s(presscoin.location)+" in "+_vm._s(presscoin.place)+"."),_c('br'),_vm._v("To see more coin press machines in this area visit our "),_c('b-link',{attrs:{"to":"/map"}},[_vm._v("Pressed Coin Map")]),_vm._v(".")],1),_c('GmapMap',{staticStyle:{"width":"100%","height":"400px"},attrs:{"center":{lat:presscoin.latitude, lng:presscoin.longitude},"zoom":18,"options":{
              mapTypeControl: true,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: false,
              styles: [
                        {
                          "elementType": "geometry",
                          "stylers": [
                            {
                              "color": "#1d2c4d"
                            }
                          ]
                        },
                        {
                          "elementType": "labels.text.fill",
                          "stylers": [
                            {
                              "color": "#8ec3b9"
                            }
                          ]
                        },
                        {
                          "elementType": "labels.text.stroke",
                          "stylers": [
                            {
                              "color": "#1a3646"
                            }
                          ]
                        },
                        {
                          "featureType": "administrative.country",
                          "elementType": "geometry.stroke",
                          "stylers": [
                            {
                              "color": "#4b6878"
                            }
                          ]
                        },
                        {
                          "featureType": "administrative.land_parcel",
                          "elementType": "labels.text.fill",
                          "stylers": [
                            {
                              "color": "#64779e"
                            }
                          ]
                        },
                        {
                          "featureType": "administrative.province",
                          "elementType": "geometry.stroke",
                          "stylers": [
                            {
                              "color": "#4b6878"
                            }
                          ]
                        },
                        {
                          "featureType": "landscape.man_made",
                          "elementType": "geometry.stroke",
                          "stylers": [
                            {
                              "color": "#334e87"
                            }
                          ]
                        },
                        {
                          "featureType": "landscape.natural",
                          "elementType": "geometry",
                          "stylers": [
                            {
                              "color": "#023e58"
                            }
                          ]
                        },
                        {
                          "featureType": "poi",
                          "elementType": "geometry",
                          "stylers": [
                            {
                              "color": "#283d6a"
                            }
                          ]
                        },
                        {
                          "featureType": "poi",
                          "elementType": "labels.text.fill",
                          "stylers": [
                            {
                              "color": "#6f9ba5"
                            }
                          ]
                        },
                        {
                          "featureType": "poi",
                          "elementType": "labels.text.stroke",
                          "stylers": [
                            {
                              "color": "#1d2c4d"
                            }
                          ]
                        },
                        {
                          "featureType": "poi.park",
                          "elementType": "geometry.fill",
                          "stylers": [
                            {
                              "color": "#023e58"
                            }
                          ]
                        },
                        {
                          "featureType": "poi.park",
                          "elementType": "labels.text.fill",
                          "stylers": [
                            {
                              "color": "#3C7680"
                            }
                          ]
                        },
                        {
                          "featureType": "road",
                          "elementType": "geometry",
                          "stylers": [
                            {
                              "color": "#304a7d"
                            }
                          ]
                        },
                        {
                          "featureType": "road",
                          "elementType": "labels.text.fill",
                          "stylers": [
                            {
                              "color": "#98a5be"
                            }
                          ]
                        },
                        {
                          "featureType": "road",
                          "elementType": "labels.text.stroke",
                          "stylers": [
                            {
                              "color": "#1d2c4d"
                            }
                          ]
                        },
                        {
                          "featureType": "road.highway",
                          "elementType": "geometry",
                          "stylers": [
                            {
                              "color": "#2c6675"
                            }
                          ]
                        },
                        {
                          "featureType": "road.highway",
                          "elementType": "geometry.stroke",
                          "stylers": [
                            {
                              "color": "#255763"
                            }
                          ]
                        },
                        {
                          "featureType": "road.highway",
                          "elementType": "labels.text.fill",
                          "stylers": [
                            {
                              "color": "#b0d5ce"
                            }
                          ]
                        },
                        {
                          "featureType": "road.highway",
                          "elementType": "labels.text.stroke",
                          "stylers": [
                            {
                              "color": "#023e58"
                            }
                          ]
                        },
                        {
                          "featureType": "transit",
                          "elementType": "labels.text.fill",
                          "stylers": [
                            {
                              "color": "#98a5be"
                            }
                          ]
                        },
                        {
                          "featureType": "transit",
                          "elementType": "labels.text.stroke",
                          "stylers": [
                            {
                              "color": "#1d2c4d"
                            }
                          ]
                        },
                        {
                          "featureType": "transit.line",
                          "elementType": "geometry.fill",
                          "stylers": [
                            {
                              "color": "#283d6a"
                            }
                          ]
                        },
                        {
                          "featureType": "transit.station",
                          "elementType": "geometry",
                          "stylers": [
                            {
                              "color": "#3a4762"
                            }
                          ]
                        },
                        {
                          "featureType": "water",
                          "elementType": "geometry",
                          "stylers": [
                            {
                              "color": "#0e1626"
                            }
                          ]
                        },
                        {
                          "featureType": "water",
                          "elementType": "labels.text.fill",
                          "stylers": [
                            {
                              "color": "#4e6d70"
                            }
                          ]
                        }
                      ]}}},[_c('GmapMarker',{attrs:{"position":{lat:presscoin.latitude, lng:presscoin.longitude},"clickable":true,"icon":{url : require('../assets/img/machine-marker.png')}},on:{"click":function($event){return _vm.openInfoWindowTemplate()}}}),_c('gmap-info-window',{attrs:{"options":{maxWidth: 300},"position":{lat:presscoin.latitude, lng:presscoin.longitude},"opened":_vm.infoWindow.open},on:{"closeclick":function($event){_vm.infoWindow.open=false}}},[_vm._v("\n              "+_vm._s(presscoin.location)+"\n          ")])],1)],1):_vm._e()])],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }